import React, {ReactElement} from 'react';
import locationLogo from '@assets/images/medops/location.svg';
const LocationLogo = (props: any): ReactElement => {
  return <img src={locationLogo} {...props} />;
};
export default LocationLogo;
